import { useSelector } from "react-redux";
import { LayoutProps } from "./props";

export default (): LayoutProps => {
  return {
    idToken: useSelector<RootReducer, string | null>(({ idToken }) => idToken)
  };
};
